import { lazy } from 'react'
import { useParams } from 'react-router-dom'
import type { LearnerScreenId } from '@app/routes/learner-route-types'
import { LearnerRouteBoundary } from '@features/learner-shell'

const LegacyCompatDashboardRoute = lazy(() =>
  import('@/legacy-compat/pages/dashboard/LegacyCompatDashboardRoute').then((module) => ({
    default: module.LegacyCompatDashboardRoute,
  })),
)

export interface LearnerLegacyRouteProps {
  readonly opensActivationKey?: boolean
  readonly screenId: LearnerScreenId
}

export function LearnerLegacyRoute({
  opensActivationKey,
  screenId,
}: LearnerLegacyRouteProps) {
  const { bookId } = useParams()

  return (
    <LearnerRouteBoundary>
      <LegacyCompatDashboardRoute
        routeBookId={bookId}
        opensActivationKey={opensActivationKey}
        lessonMode={screenId === 7}
        routeScreenId={screenId}
      />
    </LearnerRouteBoundary>
  )
}
